<p-sidebar [(visible)]="visible" position="right" (onHide)="closeSidebar()">
  <ng-template pTemplate="header">
    <span class="filter-header"> Filter </span>
  </ng-template>
  <div class="filter-wrapper">
    <div class="filter-content">
      <app-form [formConfig]="form" [hasButton]="false" [validationEmit]="validationEmit" (onChange)="valueChanged($event)" (onSubmit)="onApply($event)" [validationErrors]="validationErrors">
    </app-form>
    </div>
    <div class="filter-actions">
      <button class="btn btn-solid-main" (click)="emitValidation()">Apply</button>
      <button class="btn btn-outline-main" (click)="onClear()">Clear</button>
    </div>
  </div>
</p-sidebar>
